export enum CasinoGroup {
  CASINO = 'CASINO',
  LIVE = 'LIVE',
}

export enum CasinoGroupPathParam {
  CASINO = 'casino',
  LIVE = 'live-casino',
}

export enum CasinoSubpage {
  FAVORITES = 'favorites',
}

export const pathParamToCasinoGroupMap: Record<
  CasinoGroupPathParam,
  CasinoGroup
> = {
  [CasinoGroupPathParam.CASINO]: CasinoGroup.CASINO,
  [CasinoGroupPathParam.LIVE]: CasinoGroup.LIVE,
};

export const getGameUrl = (
  gameId: number,
  queryParams: Record<string, string | boolean | undefined | null> = {},
) => {
  const url = new URL(`/game/${gameId}`, location.origin);

  for (const [key, value] of Object.entries(queryParams)) {
    if (value !== undefined && value !== null) {
      url.searchParams.set(key, String(value));
    }
  }

  return url.pathname + url.search;
};

export const base64ToUrl = (input: string) => {
  const byteArray = Uint8Array.from(
    atob(input)
      .split('')
      .map((char) => char.charCodeAt(0)),
  );
  return URL.createObjectURL(new Blob([byteArray], { type: 'text/html' }));
};
